<template>
  <v-container fluid class="pa-0">
    <!-- <v-img :src="BgImg" contain />
    <template #sources>
      <source media="(max-width: 480px)" srcset="../assets/bg_sp.png" />
    </template>
     -->
    <picture>
      <source media="(max-width: 480px)" srcset="../assets/bg_sp.png" />
      <img :src="BgImg" class="responsive-img" />
    </picture>

    <About /> <Story />
    <!-- ゲーム説明 -->

    <!-- それぞれのタイトルへのリンク -->
    <SS />
    <ProductPage />

    <!-- 製品情報 -->
    <AppNews />
    <!-- ニュース -->
    <!-- <Caution /> -->
    <!-- 配信ガイドライン -->
  </v-container>
</template>

<script>
  import AppNews from "./AppNews.vue";

  import ProductPage from "./SoftProduct.vue";
  //  import Caution from "./CautionStream.vue";
  import About from "./AboutGame.vue";
  import image1 from "../assets/bg.png";
  import SS from "./ScreenShot.vue";
  import Story from "./GameStory.vue";

  export default {
    name: "App",
    components: {
      AppNews,
      ProductPage,
      //   Caution,
      About,
      SS,
      Story,
    },
    data: () => ({
      BgImg: image1,
    }),
  };
</script>

<style scoped>
  .bold {
    color: #ff1744;
    font-weight: bold;
  }
  .responsive-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
